<template>
  <app-popup :active.sync="isActive" title="Отправка завершена" class="employee-debtors-sms-answer-popup">

    <div class="employee-debtors-sms-answer-popup__answer-row">
      <div class="employee-debtors-sms-answer-popup__icon">
        <app-icon name="CheckIcon" size="100%"/>
      </div>
      <div class="employee-debtors-sms-answer-popup__text">
        Всего отправленных смс: {{answer}}
      </div>
    </div>

  </app-popup>
</template>

<script>
  export default {
    name: "SmsAnswer",
    data(){
      return {
        isActive: false,
        answer: null,
      }
    },
    methods: {
      open(answer){
        this.answer = answer;
        this.isActive = true;
      }
    }
  }
</script>

<style lang="scss">
  .employee-debtors-sms-answer-popup{
    &__icon{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      color: rgba(var(--app-success), 1);
      border: 2px solid rgba(var(--app-success), 1);
      border-radius: 50%;
      padding: 6px;
      margin-right: 15px;
    }

    &__answer-row{
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__text{
      line-height: 1.1;
      font-weight: 500;
    }
  }
</style>
